import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Themed generic status page — shared shell for 401/403/404/500. Reuses the
 * project theme tokens (card radius/shadow, primary brand) and branding.
 */
export default function StatusPage({ code, title, message, icon }) {
  return (
    <div className="d-flex align-items-center justify-content-center py-5">
      <div className="card text-center p-4 p-md-5" style={{ maxWidth: 480 }}>
        <div className="mb-3">
          <i className={`${icon} text-primary`} style={{ fontSize: '3rem' }} aria-hidden="true" />
        </div>
        <h1 className="display-4 fw-bold text-primary mb-2">{code}</h1>
        <h2 className="h4 mb-3">{title}</h2>
        <p className="text-muted mb-4">{message}</p>
        <div className="d-flex gap-2 justify-content-center">
          <Link to="/" className="btn btn-primary">
            <i className="fa fa-house me-2" aria-hidden="true" />
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
}
